import React from 'react'

const ControlButtons = (props) => {
  return (
    <div
      className='controlButtonsContainer'
      style={{ bottom: props.isWheelChairAvailable ? '30px' : '10px' }}
    >
      <div className='controlButton' onClick={props.reset}>
        &#x21bb;
      </div>
      <div className='controlButton' onClick={props.zoomIn}>
        +
      </div>
      <div className='controlButton' onClick={props.zoomOut}>
        -
      </div>
    </div>
  )
}

export { ControlButtons }
